import { DashboardBannerVariant } from 'features/productGrowth/types';

export const SEGMENT_MAPPING = {
  inception: 'inception',
  switcher: 'switcher',
  default: 'default',
};

export const FOCUSED_QUICK_START_GUIDE_ROUTE = '/quick_start_guide/focus';

export const PLUS_PAYROLL_PROMO_CODES = ['25EOYB', 'EOYPAY3', 'EOYPAY6'];

export const EOY_PAYROLL_PROMO_CODES = ['25EOYA', ...PLUS_PAYROLL_PROMO_CODES];

// Variants that should show the PayrollBanner instead of DashboardBanner
export const PAYROLL_BANNER_VARIANTS: DashboardBannerVariant[] = [
  'eoy_payroll_post_trial_d',
  'eoy_payroll_post_trial_existing_customer',
];
